import './widget.scss';

import { DefaultModeWidget } from './widgets/mode';
import { useDisplayStore, useRemoteStore } from '../../store/sceneStore';

export const DefaultWidgetManager = () => {
	const display = useDisplayStore();
	const remote = useRemoteStore();

	if (remote.request === 2) {
		return null;
	}

	return (
		<div className={`Modal ${display.mode ? 'Show' : ''}`}>
			<DefaultModeWidget />
		</div>
	);
};
